import React from 'react'
import './styleCalender.css';
import { Col, Row, Table, Card, Input, Button } from 'reactstrap';
import { ComponentDetailBranchs } from './ComponentDetailBranchs';
import { ComponentDetailPatient } from './ComponentDetailPatient';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Chart from 'react-apexcharts'







export const DetailProgramming = (props) => {

  const {
    typePeriod, number_format, sum_branches_recolected,
    options, series, listBranchesTree, handleGeneralPatients, classifications,
    valid_loading_patient, patient_excluded, handleClosedInformations, handleChangeTypePerson, type_filter_person,
    patient_Include, patient_Excluded, total_patient,
    filterCon, setFilterCon,
    filterSin, setFilterSin, totalP, exportToExcel, navigateDetailPatient, branches_programming, sumre,
    chartPeriod, sum_branches, setSelectedRows, buildSelectedValues, selectedRows,
    modalviewb, toggleb, handlePreviewB, CreateMoveFlow

  } = props;


  const ingresoRecaudado = patient_excluded
    .filter(item => item.patient_invoice !== "False")
    .reduce((total, item) => total + (item.amount || 0), 0);

  const ingresoNoRecaudado = patient_excluded
    .filter(item => item.patient_invoice === "False")
    .reduce((total, item) => total + (item.amount || 0), 0);

  const pacientesRecaudados = patient_excluded.filter(
    item => item.patient_invoice !== "False"
  );

  const pacientesfacturado = patient_excluded.filter(
    item => item.patient_invoice === "False"
  );

  // * STYLES DATA TABLE
  const headerStyle = {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "11px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle = {
    fontSize: "11px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",

  };

  const centerStyle = {
    ...cellStyle,
    textAlign: "center",
    zIndex: 2
  };





  return (
    <>
      <Col sm="12">

        <Row>
          <Col sm="12" className={typePeriod !== "" ? "p-l-0 p-r-0 pb-4" : "d-none"} >
            <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "15px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth" }}>
              <div style={{
                backgroundColor: '#47a2dda6',
                color: '#fff',
                padding: '5px 10px',
                borderRadius: '8px',
                marginBottom: '10px',
                fontWeight: 'bold',
                textAlign: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}>
                Periodo seleccionado:&nbsp;{typePeriod}
              </div>
              <Col sm="12">
                <Row>
                  <Col sm="2" className='p-l-0 p-r-0' >
                    <Col sm="12" className='p-l-0 p-r-0' >
                      <Card style={{ height: "80px" }} className='shadow' >
                        <Col sm="12">
                          <Row>
                            <Col sm="3" className='pt-3 p-l-0 p-r-0' >
                              <img style={{ height: "100%", filter: "brightness(0.5)" }} src={require("../../assets/images/loginHelenLabs/InvoiceCFDI/Egress.svg")} />
                            </Col>
                            <Col sm="9" className='pt-3'>
                              <label style={{ fontSize: "11px" }} className='f-w-600  txt-secondary'>Saldo Recuperado</label>  <br /> <b className=''  >${number_format(sum_branches_recolected, 2) ?? 0}</b>
                            </Col>
                          </Row>
                        </Col>
                      </Card>
                    </Col>
                    <Col sm="12" className='p-l-0 p-r-0' >
                      <Card style={{ height: "80px" }} className='shadow'>
                        <Col sm="12">
                          <Row>
                            <Col sm="3" className='pt-3 p-l-0 p-r-0'>
                              <img style={{ height: "100%", filter: "grayscale(1)" }} src={require("../../assets/images/loginHelenLabs/InvoiceCFDI/Egress.svg")} />
                            </Col>
                            <Col sm="9" className='pt-3'>
                              <label style={{ fontSize: "11px" }} className='f-w-600 txt-secondary'>Saldo Programado</label>  <br /> <b className=''  >${number_format(sum_branches, 2) ?? 0}</b>
                            </Col>
                          </Row>
                        </Col>
                      </Card>
                    </Col>
                  </Col>
                  <Col sm="10" >
                    <Chart options={chartPeriod.options} series={chartPeriod.series} type="line" height={350} />

                  </Col>

                </Row>
              </Col>




            </Card>

          </Col>
          <Col sm="4" className='p-l-0 p-r-0' >
            <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "15px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", transformOrigin: "top left", textAlign: "left" }}>
              <ComponentDetailBranchs
                {
                ...{
                  options, series, sum_branches_recolected, listBranchesTree, handleGeneralPatients, classifications, typePeriod, branches_programming, sumre
                }
                }
              />
            </Card>

            <Col className='shadow-sm'
              style={{
                paddingTop: "15px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)",
                transformOrigin: "top left", textAlign: "left", backgroundColor: 'white', border: '1px solid #e0e0e0',
                borderRadius: '10px', padding: '12px', fontSize: '12px'
              }}


            >
              <div style={{
                fontWeight: 'bold', background: '#0d3b59', color: 'white',
                padding: '6px', borderRadius: '8px', marginBottom: '10px',
                textAlign: 'center', fontSize: '12px'
              }} >
                Detallado de Sucursales

              </div>
              <DataTable
                value={listBranchesTree?.flatMap(branch => branch.children)}
                dataKey="idBranch"
                paginator
                rows={10}
                rowsPerPageOptions={[10, 50, 100, 200]}
                responsiveLayout="scroll"
                emptyMessage={
                  <div className="text-center">
                    <img
                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                      style={{ width: "45%" }}
                      alt="Sin resultados"
                    />
                    <br />
                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                      No hay sucursales disponibles.
                    </p>
                  </div>
                }
              >
                <Column header="#" body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} />
                <Column field="text" header="Sucursal" headerStyle={headerStyle} style={centerStyle} />
                <Column
                  header="Acciones"
                  body={(row) => (
                    <div title="Detallado de pacientes" className="badge-branches-view pointer" onClick={() => handleGeneralPatients(row.id, typePeriod)}>
                      <i className="fa fa-eye f-12"></i>
                    </div>
                  )}
                  headerStyle={headerStyle}
                  style={centerStyle}
                />
              </DataTable>
            </Col>

            <Col className='shadow-sm'
              style={{
                paddingTop: "5px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)",
                transformOrigin: "top left", textAlign: "left", backgroundColor: 'white', border: '1px solid #e0e0e0',
                borderRadius: '10px', padding: '12px', fontSize: '12px'
              }}>
              <div style={{
                fontWeight: 'bold', background: '#0d3b59', color: 'white',
                padding: '6px', borderRadius: '8px', marginBottom: '10px',
                textAlign: 'center', fontSize: '12px'
              }} >
                Mover Flujo B a Flujo A

              </div>
              <Col sm="12" className='pl-0 pr-0'>
                {
                  selectedRows.length > 0 && <>
                    <label className='f-w-600' >Se han seleccionado {selectedRows.length} pacientes</label>
                    <Button
                      color='success'
                      block
                      title="Mandar a flujo A"
                      onClick={handlePreviewB}
                      //  disabled={loadingExcel || activeIndex === steps.length - 1}
                      style={{
                        fontSize: '12px',
                        padding: '6px 12px',
                      }}
                    >
                      Confirmar
                    </Button>




                  </>
                }
              </Col>



            </Col>

          </Col>
          <Col sm="8" className='p-l-0 p-r-0' >
            <Col sm="14" style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "20%" }}
            >


              <Col sm="12" className='p-l-0 pb-4' >
                <Row>
                  <Col sm="3">
                    <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                      <Row>
                        <Col sm="9">
                          <label htmlFor=""> Ingreso Recaudado</label> &nbsp; <br />
                          <b className="f-w-600">${ingresoRecaudado ?? 0}</b>
                        </Col>
                        <Col sm="3" className="d-flex justify-content-center align-items-center">
                          <i className="fa fa-tags " style={{ fontSize: "23px", color: "#f59e0b" }}></i>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col sm="3">
                    <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                      <Row>
                        <Col sm="9">
                          <label htmlFor=""> Ingreso Cancelado</label> &nbsp; <br />
                          <b className="f-w-600">${ingresoNoRecaudado ?? 0}</b>
                        </Col>
                        <Col sm="3" className="d-flex justify-content-center align-items-center">
                          <i className="fa fa-tags txt-danger" style={{ fontSize: "23px" }}></i>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col sm="3">
                    <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                      <Row>
                        <Col sm="9">
                          <label htmlFor="">Total de pacientes</label> &nbsp; <br />
                          <b className="f-w-600">{pacientesRecaudados.length ?? 0}</b>
                        </Col>
                        <Col sm="3" className="d-flex justify-content-center align-items-center">
                          <i className="fa fa-users txt-secondary" style={{ fontSize: "23px" }}></i>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col sm="3">
                    <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                      <Row>
                        <Col sm="9">
                          <label htmlFor="">Total Facturado</label> &nbsp; <br />
                          <b className="f-w-600">{pacientesfacturado.length ?? 0}</b>
                        </Col>
                        <Col sm="3" className="d-flex justify-content-center align-items-center">
                          <i className="icofont icofont-file-pdf txt-danger" style={{ fontSize: "23px" }}></i>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>

              <div style={{
                backgroundColor: '#587d95',
                color: '#fff',
                padding: '5px 10px',
                borderRadius: '8px',
                marginBottom: '10px',
                fontWeight: 'bold',
                textAlign: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}>
                Pacientes asociados
              </div>





              <Col>



              </Col>






            </Col>
            <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
              {
                valid_loading_patient &&
                <>
                  <ComponentDetailPatient
                    {
                    ...{
                      patient_excluded, handleClosedInformations, handleChangeTypePerson, type_filter_person,
                      number_format, patient_Include, patient_Excluded, total_patient,
                      filterCon, setFilterCon,
                      filterSin, setFilterSin, totalP, exportToExcel, navigateDetailPatient, setSelectedRows, buildSelectedValues, selectedRows
                    }
                    }
                  />

                </>

              }

            </Card>
          </Col>
        </Row>
      </Col>

    </>
  )

}
